/**
 * Formats an amenity name from snake_case to Title Case
 * e.g., "desk_chair" → "Desk Chair"
 * e.g., "on-site_gym" → "On-site Gym"
 */
export const formatAmenityName = (name: string): string => {
  if (!name) return "";

  return name
    .split("_")
    .map((word) => {
      // Handle hyphenated words - only capitalize first part
      if (word.includes("-")) {
        const parts = word.split("-");
        return parts
          .map((part, index) => (index === 0 ? part.charAt(0).toUpperCase() + part.slice(1) : part))
          .join("-");
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

/**
 * Formats a category type name from snake_case to Title Case
 * e.g., "property_services" → "Property Services"
 */
export const formatCategoryName = (type: string): string => formatAmenityName(type);
